import { useState, useEffect } from "react";
import { useGetAllInstitutesQuery } from "src/services/InstituteService";

const useInstitutes = () => {
    const [institutes, setInstitutes] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllInstitutesQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setInstitutes(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { institutes, isDataLoading };
};

export default useInstitutes;
